import React, {Component} from 'react';
import Counter from './Counter';
import T from 'i18n-react';


class Product extends Component{
	constructor(props){
		super(props);
        this.state = {
            selectedProduct: {},
            quickViewProduct: {},
            isAdded: false
        }
    }

    handleAddToCart = (image, name, price, id, idProd, quantity, available) => {
        this.setState({
            selectedProduct: {
                image: image,
                name: name,
                price: parseFloat(price.replace(",", ".")),
                id: id,
                idProd: idProd,
                quantity: quantity,
                available: available
            }
        }, function(){
            this.props.addToCart(this.state.selectedProduct);
        });

        this.setState({
            isAdded: true
        }, function(){
            setTimeout(() => {
                this.setState({
                    isAdded: false,
                    selectedProduct: {}
                });
            }, 3750);
        });
    };

    addToCart(image, name, price, id, idProd, quantity, available){
        if (this.props.cartItems.length > 0 && this.props.cartItems.filter(x => x.id === id)[0]) {
            //let existentQuantity = this.props.cartItems.filter(x => x.id === id)[0].quantity;
            let availableQuantity = this.props.cartItems.filter(x => x.id === id)[0].available;

            /*console.log('existentQuantity: ' + existentQuantity);
            console.log('quantity: ' + quantity);
            console.log('availableQuantity: ' + availableQuantity);*/

            if (quantity <= availableQuantity) {
                this.handleAddToCart(image, name, price, id, idProd, quantity, available);
            } else {
                alert(T.translate("labels.quantityNotAvailableInCart"));
            }
        } else {
            (available !== 0) ?
            this.handleAddToCart(image, name, price, id, idProd, quantity, available):
                alert(T.translate("labels.quantityNotAvailableInCart"));
        }
    }

    quickView(image, name, price, id, idProd, description, descriptionEn, available, typeProduct){
        this.setState({
            quickViewProduct: {
                image: image,
                name: name,
                price: parseFloat(price),
                id: id,
                idProd: idProd,
                description: description,
                descriptionEn: descriptionEn,
                available: available,
                typeProduct: typeProduct
            }
        }, function(){
            this.props.openModal(this.state.quickViewProduct);
        })
    }

    parseNum = (num) => {
        let numFloat = num.toLocaleString(undefined, {minimumFractionDigits: 2});
        return this.props.locale === 'it' ? numFloat : numFloat.replace(",", ".");
    };

    render(){
        let image = (this.props.id !== 1) ? this.props.image : 'products-img/54173/maldives1.jpg';
        let name = this.props.name;
        let price = this.props.price && this.parseNum(this.props.price);
        let id = this.props.id;
        let idProd = this.props.idProd;
        let quantity = this.props.productQuantity;
        let description = this.props.description;
        let descriptionEn = this.props.descriptionEn;
        let available = this.props.available;
        let typeProduct = this.props.type;

        let actionButton = '',
            productTypeClass = '';

        if (typeProduct === 1) {
            productTypeClass = 'product-type1';
        } else if (typeProduct === 2) {
            productTypeClass = 'product-type2';
        } else if (typeProduct === 3) {
            productTypeClass = 'product-type3';
        } else {
            productTypeClass = 'product-type4';
        }

        if (id !== 1) {
            if (this.props.available > 0) {
                actionButton = (
                    <div className="product-action">
                        <button className={!this.state.isAdded ? "" : "added"}
                                type="button"
                                disabled={this.state.isAdded}
                                onClick={this.addToCart.bind(this, image, name, price, id, idProd, quantity, available)}>
                            {!this.state.isAdded ? T.translate("labels.addToCart") : T.translate("labels.addedToCart")}</button>
                    </div>
                )
            } else {
                actionButton = (
                    <div className="product-action">
                        <button style={{backgroundColor: 'grey'}} disabled={true}>
                            {T.translate("labels.outOfStock")}
                        </button>
                    </div>
                )
            }
        } else {
            actionButton = (
                <div className="product-action">
                    <button onClick={this.quickView.bind(this, image, name, price, id, idProd, description, descriptionEn, available, typeProduct)}>
                        {T.translate("labels.beTheFirst")}
                    </button>
                </div>
            )
        }

        return(
            <div className={`product ${productTypeClass}`}>
                <div className="product-image" style={{backgroundImage: `url(${image})`}}
                     onClick={this.quickView.bind(this, image, name, price, id, idProd, description, descriptionEn, available, typeProduct)}>
                </div>
                <div className="product-name" style={this.props.name.length > 36 ? {fontSize: 12} : {fontSize: 16}}>{this.props.name}</div>
                {
                    (id !== 1) ?
                        <p className="product-price">{price}</p> : <div className="promo-subtitle">{T.translate("labels.promoProdSubtitle")}</div>
                }

                {
                    available || available === 0 ?
                        <p className={`product-available ${available === 0 ? 'out-of-stock' : ''}`}>
                            {available} {T.translate("labels.available")}
                        </p> : <div />
                }

                {
                    id !== 1 ?
                    <Counter
                        productAvail={available}
                        productQuantity={quantity}
                        updateQuantity={this.props.updateQuantity}
                    /> :
                    <div>&nbsp;</div>
                }
                {actionButton}
            </div>
        )
    }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js